import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import chatStorage from './chatStorage';
import IncomeMessage from './IncomeMessage';
import OutgoingMessage from './OutgoingMessage';
import searchStorage from '../../storages/mobx/searchStorage';
import currentMessages from './storages/currentMessages';
import LoaderAbsolute from '../../components/LoaderAbsolute';

function ChatMessages() {
  const { account: { id, avatar } } = chatStorage.currentChat;
  const { messagesList: messages, loading } = currentMessages;
  const { searchedId } = searchStorage;
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    if (!searchedId) {
      messagesEndRef.current.scrollIntoView({});
    } else {
      const el = document.getElementById(searchedId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      } else {
        messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  useEffect(scrollToBottom, [messages, messages.length, searchedId]);
  useEffect(() => {
    chatStorage
      .loadMessagesForCurrentChat()
      .then((r) => {
        if (searchedId) {
          const el = document.getElementById(searchedId);
          if (el) {
            el.scrollIntoView();
          }
        }
      });
  }, [chatStorage.currentChatID]);
  if (!messages) return null;
  return (
    <>
      {messages.slice().sort((a, b) => (a.id == b.id ? 0 : (+a.id < +b.id ? -1 : 1))).map((message) => {
        if (message.sender > 0) {
          return <OutgoingMessage key={message.id.toString()} {...message} />;
        }
        return <IncomeMessage key={message.id.toString()} avatar={avatar} {...message} />;
      })}
      <div ref={messagesEndRef} />
      {loading && <LoaderAbsolute />}
    </>
  );
}

ChatMessages.propTypes = {};

export default observer(ChatMessages);
